<template>
  <div class="app-layout-member" :class="data.logoLink ? 'has-logo' : ''">
    <div class="app-layout-member__inner">
      <div class="app-layout-member__title" v-if="data.title">{{ data.title }}</div>
      <div class="app-layout-member__logo" v-if="data.logoLink">
        <img :src="data.logoLink" alt="logo">
      </div>
      <div class="app-layout-member__description" v-if="data.description">
        {{ data.description }}</div>
      <div class="app-layout-member__info" v-if="data.info">
        <div class="app-layout-member__info-title" v-if="data.info.title">
          {{ data.info.title }}</div>
        <div class="app-layout-member__info-item"
             :class="!item.label ? 'unlabeled' : ''" v-for="(item, idx) in data.info.items"
             :key="`info${idx}`">
          <span v-if="item.label">{{ item.label }}</span>
          <a :href="item.href"
             :class="[item.href.includes('tel') ? 'is-tel': '',
             item.href.includes('fax') ? 'is-fax':'']"
             v-if="item.href.includes('tel') || item.href.includes('fax')">
            {{ item.text }}</a>
          <a
             @click.prevent="openLink(item.href)"
             v-else>
            {{ item.text }}</a>
        </div>
      </div>
      <div class="app-layout-member__location" v-if="data.location">
        <div class="app-layout-member__location-title"
             v-if="data.location.title">{{ data.location.title }}</div>
        <div class="app-layout-member__location-item"
        v-for="(item, idx) in data.location.items" :key="`location${idx}`">
          <div v-html="item.text"/>
        </div>
      </div>
      <div class="app-layout-member__close"
           @click="$emit('member-close')">{{ data.closeText }}</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'AppLayoutMember',
  props: ['data'],
  components: {
  },
  methods: {
    openLink(href) {
      let link = '';
      if (href.includes('https')) {
        link = href;
      } else {
        link = `https://${href}`;
      }
      window.open(link, '_blank');
    },
  },
};

</script>

<style lang="scss">
  @import "app-layout-member";
</style>
